<template>
  <v-card :elevation="6" class="mx-auto pa-2 rounded-lg" style="min-height: 320px;">
    <grafico-vazio v-if="dados.length === 0" :min-height="320" />
    <grafico-barras-horizontais
      v-else
      id="grafico-subtipo-acao"
      :category-field="`nome`"
      :value-field="`valor`"
      :dados="dados"
      :title="`R$ ${$tc('label.sub_tipo', 1)}`"
      :colors="cores"
    />
  </v-card>
</template>

<script>
import GraficoBarrasHorizontais from '@/produto/shared-components/chart/GraficoBarrasHorizontais';
import { buscarSubtipo } from '@/common/resources/akzo-chart';
import GraficoVazio from './GraficoVazio';

export default {
  name: 'GraficoBarrasHorizontaisSubtipo',
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    params: {
      handler() {
        this.buscarDados();
      },
      deep: true,
    },
  },
  components: {
    GraficoBarrasHorizontais,
    GraficoVazio,
  },
  data() {
    return {
      dados: [],
      cores: ['#4285f4'],
    };
  },
  methods: {
    buscarDados() {
      buscarSubtipo(this.params, this.$resource)
        .then((response) => {
          const dados = (response.data || [])
            .filter((item) => item.id !== null)
            .map((item, index) => ({
              nome: item.nome,
              valor: item.valor || 0,
              color: this.cores[index % this.cores.length],
            }));
          const total = dados.reduce((acc, item) => acc + (item.valor || 0), 0);
          dados.forEach((item) => {
            const perc = total > 0 ? ((item.valor || 0) / total) * 100 : 0;
            item.percentual = perc.toFixed(2).replace('.', ',');
          });
          this.dados = dados;
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  mounted() {
    this.buscarDados();
  },
};
</script>
